import React, { FC } from 'react';
import tishi from '../../assets/images/tishi.png';
const PitModuleShortcut: FC = () => {
  return (
    <div className="rangeBox">
      <img src={tishi} alt="" />
    </div>
  );
};
export default PitModuleShortcut;
